import templateUrl from './sign-off.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    onSignedOff: '&',
    units: '<',
    chosenUnits: '<',
    isTreat: '<'
  },
  controller: class SignOffComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.onSignedOff(
        this.EventEmitter({
          signature: this.signature
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/sign-off/sign-off.component.js